import { theme as defaultTheme } from "@chakra-ui/react";
import { remCalc } from "./utils";

const tiniest = remCalc(2);
const tinier = remCalc(4);
const tiny = remCalc(8);
const smallest = remCalc(12);
const smaller = remCalc(16);
const small = remCalc(24);
const big = remCalc(32);
const bigger = remCalc(40);
const biggest = remCalc(64);
const huge = remCalc(96);
const huger = remCalc(128);
const hugest = remCalc(160);

/**
 * The space values for the new design system as pixel values.
 * Use these when you do not want the size to scale with font size adjustments.
 * E.g., border radii, padding, etc.
 */
export const spaceInPx = {
  tiniest: "2px",
  tinier: "4px",
  tiny: "8px",
  smallest: "12px",
  smaller: "16px",
  small: "24px",
  big: "32px",
  bigger: "40px",
  biggest: "64px",
  huge: "96px",
  huger: "128px",
  hugest: "160px",
};

// Space variables that are used for setting margin, padding, gap, etc.
export const space = {
  tiniest,
  tinier,
  tiny,
  smallest,
  smaller,
  small,
  big,
  bigger,
  biggest,
  huge,
  huger,
  hugest,
  containerPx: {
    mobile: smaller, // @TODO: update to bigger once grid is ready
    tablet: bigger,
    desktop: biggest,
    ultraWide: huge,
  },
  sectionSpacingY: {
    base: huge,
    md: hugest,
  },
};

// Size variables that are used for setting width, height, boxSize, etc.
// Include the same keys and values set for `space`
export const sizes = {
  ...space,
  icon: {
    xs: remCalc(12),
    sm: remCalc(16),
    md: remCalc(20),
    lg: remCalc(24),
    xl: remCalc(32),
    "2xl": remCalc(48),
    "3xl": remCalc(64),
  },
  // If all legacy styles are removed from the site, we may not need these defaults from Chakra, either
  ...defaultTheme.space,
  // -----------------------------------
  // Legacy theme sizes
  // -----------------------------------
  max: "max-content",
  min: "min-content",
  full: "100%",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  container: {
    article: "824px",
    section: "1200px",
    page: "1440px",
  },
  cardMaxW: "460px",
  mediaMaxW: {
    mobile: "460px",
  },
  // Section max width value based on the updated design system
  // Should be used sparingly until we fully migrate to the new system grid
  section: "1320px",
};
